function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCallSpeakersi = function SvgCallSpeakersi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "m7.044 7.264 6.91-3.476a.8.8 0 0 1 .78.033.8.8 0 0 1 .38.681v14.553a.8.8 0 0 1-1.16.715L7.03 16.286H2.847a.8.8 0 0 1-.8-.8V8.064a.8.8 0 0 1 .8-.8zm.97 1.304V15l5.502 2.767V5.8zm10.543-1.203a6.246 6.246 0 0 1 0 8.828.8.8 0 0 0 0 1.131.8.8 0 0 0 1.131 0 7.85 7.85 0 0 0 0-11.091.8.8 0 1 0-1.131 1.132m-1.928 1.923a3.58 3.58 0 0 1 0 5.061.8.8 0 1 0 1.131 1.132 5.18 5.18 0 0 0 0-7.325.8.8 0 1 0-1.131 1.132m-12.98-.424v5.822h2.766V8.864H3.647z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCallSpeakersi);
export default ForwardRef;